import { useCallback, useEffect, useRef } from 'react';
const toError = (value) => (value instanceof Error ? value : new Error(String(value)));
const releasePermissionStatus = (statusRef, next) => {
    const previous = statusRef.current;
    if (previous === null || previous === next)
        return;
    previous.onchange = null;
};
const useGeolocationPermission = ({ errorReporter, setGeolocationStatus, setIsGettingLocation }) => {
    const permissionStatusRef = useRef(null);
    useEffect(() => () => {
        if (permissionStatusRef.current) {
            permissionStatusRef.current.onchange = null;
            permissionStatusRef.current = null;
        }
    }, []);
    const getGeolocationStatus = useCallback(async () => {
        if (!navigator?.permissions?.query) {
            setGeolocationStatus('prompt');
            return 'prompt';
        }
        setIsGettingLocation(true);
        let state = 'prompt';
        try {
            const result = await navigator.permissions.query({ name: 'geolocation' });
            state = result.state;
            releasePermissionStatus(permissionStatusRef, result);
            permissionStatusRef.current = result;
            result.onchange = () => {
                setGeolocationStatus(result.state);
            };
        }
        catch (error) {
            errorReporter.warning(toError(error));
            state = 'prompt';
        }
        setGeolocationStatus(state);
        setIsGettingLocation(false);
        return state;
    }, [errorReporter, setGeolocationStatus, setIsGettingLocation]);
    return { getGeolocationStatus };
};
export default useGeolocationPermission;
